/*
 * Sticky scrollytelling dla sekcji "Jak to dziala".
 *
 * Lewa kolumna trzyma jeden kadr 4:5 (position:sticky), prawa przewija sie
 * krokami. Krok staje sie aktywny, gdy przecina srodek viewportu - stan
 * wynika z pozycji scrolla, wiec scroll w gore dezaktywuje go tak samo.
 * Zdjecie po lewej przelacza sie na kadr przypisany do aktywnego kroku:
 * zdjecie pupila -> grawer laserowy -> gotowa bizuteria.
 *
 * Bez JS: widoczny jest pierwszy kadr i wszystkie kroki (opacity z CSS
 * dotyczy tylko stanu nieaktywnego, tresc pozostaje czytelna), wiec sekcja
 * dziala jako zwykla lista krokow.
 */
(() => {
  const flows = document.querySelectorAll('[data-flow]');
  if (!flows.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  flows.forEach((flow) => {
    const steps = Array.from(flow.querySelectorAll('[data-flow-step]'));
    const shots = Array.from(flow.querySelectorAll('[data-flow-shot]'));
    const rail = flow.querySelector('[data-flow-rail]');
    const media = flow.querySelector('.neckle-flow__media');
    const frame = flow.querySelector('.neckle-flow__frame');
    if (steps.length < 2 || !shots.length) return;

    let current = -1;
    let flowInRange = false;
    let deferredAssetsLoaded = false;

    const loadDeferredAssets = () => {
      if (deferredAssetsLoaded) return;
      deferredAssetsLoaded = true;
      flow.querySelectorAll('[data-flow-src]').forEach((image) => {
        if (image.dataset.flowSrcset) image.srcset = image.dataset.flowSrcset;
        image.src = image.dataset.flowSrc;
      });
      flow.querySelectorAll('video[data-flow-poster]').forEach((video) => {
        video.poster = video.dataset.flowPoster;
      });
    };

    /*
     * Na telefonie sticky kadr oddzielal sie od tresci krokow, a przewijany
     * tekst przechodzil pod nim. Uzywamy tych samych elementow (bez
     * duplikowania i ponownego pobierania filmow), ale wstawiamy kazdy kadr
     * bezposrednio do odpowiadajacego mu kroku. Po powrocie na desktop kadry
     * wracaja do wspolnej, przyklejonej ramki.
     */
    const mobileLayout = window.matchMedia('(max-width: 749px)');
    const setLayout = (isMobile) => {
      if (!media || !frame) return;

      if (isMobile) {
        shots.forEach((shot, index) => {
          if (steps[index]) steps[index].prepend(shot);
        });
        flow.classList.add('is-mobile-stacked');
      } else {
        shots.forEach((shot) => frame.append(shot));
        flow.classList.remove('is-mobile-stacked');
      }
    };

    setLayout(mobileLayout.matches);
    mobileLayout.addEventListener('change', (event) => setLayout(event.matches));

    const activate = (index, forcePlaybackSync = false) => {
      if (index === current && !forcePlaybackSync) return;
      current = index;
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      shots.forEach((shot, i) => {
        const active = i === index;
        shot.classList.toggle('is-active', active);
        // Film odtwarza sie tylko, gdy jego krok jest aktywny - nie w tle
        // przez cala reszte scrolla. Bez auto-odtwarzania pod reduced
        // motion: kontrolki zostaja widoczne, wiec da sie wlaczyc recznie.
        const video = shot.querySelector('[data-flow-video]');
        if (!video) return;
        const playbackRate = Number(video.dataset.flowPlaybackRate || 1);
        video.defaultPlaybackRate = playbackRate;
        video.playbackRate = playbackRate;
        const setupSoftLoop = () => {
          const configuredLoopEnd = Number(video.dataset.flowLoopEnd || 0);
          const loopEnd = configuredLoopEnd > 0 ? configuredLoopEnd : video.duration;
          if (!Number.isFinite(loopEnd) || loopEnd <= 0.24 || video.dataset.flowLoopReady) return;
          video.dataset.flowLoopReady = 'true';
          let loopFading = false;
          video.addEventListener('timeupdate', () => {
            if (loopFading || video.currentTime < loopEnd - 0.12) return;
            loopFading = true;
            shot.classList.add('is-loop-fading');
            window.setTimeout(() => {
              video.pause();
              let revealed = false;
              const revealStart = () => {
                if (revealed) return;
                revealed = true;
                shot.classList.remove('is-loop-fading');
                loopFading = false;
                if (shot.classList.contains('is-active') && !reducedMotion) video.play().catch(() => {});
              };
              video.addEventListener('seeked', revealStart, { once: true });
              video.currentTime = 0;
              window.setTimeout(revealStart, 300);
            }, 220);
          });
        };
        if (video.hasAttribute('data-flow-soft-loop')) {
          if (video.readyState >= 1) setupSoftLoop();
          else video.addEventListener('loadedmetadata', setupSoftLoop, { once: true });
        }
        if (active && flowInRange && !reducedMotion) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      // Rail pokazuje, ktory to krok z ilu - stan procesu, nie ozdoba.
      if (rail) rail.style.height = `${((index + 1) / steps.length) * 100}%`;
    };

    // rootMargin scisla pole detekcji do waskiego pasa w srodku ekranu -
    // aktywny jest ten krok, ktory akurat przez niego przechodzi.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = steps.indexOf(entry.target);
        if (index !== -1) activate(index);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    steps.forEach((step) => observer.observe(step));
    activate(0);

    // Filmy z tej sekcji sa ponizej pierwszego ekranu. Uruchomienie pierwszego
    // kadru od razu pobieralo kilka MB, zanim klient zblizyl sie do procesu.
    // Zaczynamy odtwarzanie dopiero w poblizu sekcji i zatrzymujemy po wyjsciu.
    const playbackObserver = new IntersectionObserver(([entry]) => {
      const nextInRange = entry.isIntersecting;
      if (nextInRange === flowInRange) return;
      if (nextInRange) loadDeferredAssets();
      flowInRange = nextInRange;
      activate(current < 0 ? 0 : current, true);
    }, { rootMargin: '300px 0px' });
    playbackObserver.observe(flow);
  });
})();
